export default "__VITE_ASSET__DHtfW4iz__"